import React from 'react'

interface MarqueeProps {
  start: { x: number; y: number }
  end: { x: number; y: number }
}

export const Marquee: React.FC<MarqueeProps> = ({ start, end }) => {
  const left = Math.min(start.x, end.x)
  const top = Math.min(start.y, end.y)
  const width = Math.abs(end.x - start.x)
  const height = Math.abs(end.y - start.y)

  return (
    <div
      className="absolute border-2 border-blue-400 bg-blue-400/10 pointer-events-none z-30"
      style={{ left, top, width, height }}
    />
  )
}
